<template>
    <div>
        <div v-if="lastReceipt">

            <b-alert :show="lastReceipt.status == 'pending'">Sua fatura está em processamento</b-alert>
            <b-alert :show="lastReceipt.status == 'canceled'" variant="danger">Sua última fatura está cancelada</b-alert>
            <b-alert :show="lastReceipt.status == 'failed'" variant="danger">O pagamento da sua última fatura falhou</b-alert>
        </div>
        <div class="my-4">

            <!-- Header -->
            <div class="container">
                <div class="fs-5 font-weight-500">
                    Minha Assinatura
                </div>
            </div>

            <!-- Subscription -->
            <div class="container mt-4">
                <subscription-manager />
            </div>

            <!-- Cards -->
            <div class="container mt-4">
                <cards-manager :pagarme-key="pagarmeKey" />
            </div>

            <!-- Customer -->
            <div class="container mt-4">
                <customer-manager />
            </div>

            <!-- Receipts -->
            <div class="container mt-4">
                <receipt-manager @receiptsEmit="getLastReceipt" />
            </div>
        </div>
    </div>
</template>

<script>

import CustomerManager from './customer/CustomerManager';
import CardsManager from './cards/CardsManager';
import SubscriptionManager from './subscription/SubscriptionManager';
import ReceiptManager from './receipts/ReceiptManager';

export default {
    props: {
        pagarmeKey: {
            type: String,
            required: true
        },
    },
    components: {
        CustomerManager,
        CardsManager,
        SubscriptionManager,
        ReceiptManager
    },
    data(){
        return{
            lastReceipt: null
        }
    },

    methods: {
        getLastReceipt(data){
            this.lastReceipt = data[0];
        }
    }

}
</script>

<style scoped>

</style>
